import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import BookingForm from "@/components/BookingForm";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import { track } from "@/lib/tracker";

export default function Home() {
  useEffect(() => {
    track("visit");
  }, []);

  return (
    <div className="min-h-screen bg-night text-[#F8F5FF] font-body overflow-x-hidden" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Gallery />
        <BookingForm />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
